import { combine, withCallback, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { toaster } from 'utils/toast-wrapper'
import { admin } from 'routes/route.map'

import TournamentsAddComponent from './component'

export const TournamentsAdd = combine(
  withContext(
    'adminTournamentService',
    ServicesContext,
    ({ adminTournamentService }) => adminTournamentService
  ),
  withCallback(
    'onSubmit',
    ({ adminTournamentService }, { history }) =>
      async (tournamentDTO) => {
        await adminTournamentService.addTournament(tournamentDTO)
        toaster.info('Tournament has been successfully created')
        history.push(admin.tournaments())
      },
    []
  )
)(TournamentsAddComponent)
